jQuery(function($) {
    if ($('.af-calculator').length === 0) return; // only run on pages with the calculator

    /***** Format and Update Fields on Input *****/
    $('.af-calculator .calc-input input').on('input', function() {
        const element   = $(this);
        const decimals  = element.hasClass('calc-input-decimal');
        const type      = element.attr('type');
        const dataType  = element.data('type');
        let numVal      = element.val().replace(/[^\d\.]/g, ""); // remove non digit non dot characters
        const parentId  = element.parents('.af-calculator').data('id');

        if (type === 'range') {
            if (dataType === 'loan-percent') { // no extra action if dataType == 'linked'
                const baseValue = +$(`#purchase_price-${parentId}`).val().replace(/\D/g, "");
                numVal = numVal * baseValue / 100;
                numVal = formatNumber(Math.round(numVal), false);
            }

            let id = element.attr('id').replace('_range', '');
            $('#' + id).val(numVal);
        } else if (dataType) { // if set it links to the range we need to update
            let id = element.attr('id') + '_range';
            numVal = +numVal;
            if (isNaN(numVal)) numVal = 0;

            if (dataType === 'loan-percent') { // no extra action if dataType == 'linked'
                const baseValue             = +$(`#purchase_price-${parentId}`).val().replace(/\D/g, "");
                if (baseValue == 0) numVal  = 0; // prevent division by 0
                else                numVal  = numVal / baseValue * 100;
            }

            $('#' + id).val(numVal);
            $('#' + id).css('--value', numVal)
            formatNumberField(element, decimals);
        } else {
            formatNumberField(element, decimals);
        }

        calculateMortgageAPR(parentId);
    });

    $('.af-calculator .calc-input select').on('change', function(e) {
        const parentId = $(e.target).parents('.af-calculator').data('id');
        calculateMortgageAPR(parentId);
    });

    /***** Format Numbers *****/
    function formatNumber(n, allowNegative = true) { // format number 1234567 to 1,234,567
        if (typeof n === 'number') n = Math.round(n); // remove decimals
        if (typeof n !== 'string') n = n.toString();

        const isNegative = allowNegative && n[0] == '-';
        n = n.replace(/\D/g, ""); // remove non-numbers

        let result = n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (isNegative) result = '-' + result;

        return result;
    }

    function formatDecimal(n) { // always from user input, no need to keep negative numbers
        n = n.replace(/[^\d\.]/g, ""); // remove non digit non dot characters
        if (isNaN(n)) return "0";

        const numArr = n.split('.');
        hasDecimal = numArr[1] && numArr[1].length;
        if (!hasDecimal) {
            numArr[0] = +numArr[0]; // remove leading 0s
            return numArr.join('.');
        }

        n = +n;
        n = n.toFixed(3); // remove extra decimals
        if (n.endsWith('0')) n = n.slice(0, -1); // remove third decimal if 0
        if (n.endsWith('0')) n = n.slice(0, -1); // remove second decimal if 0
        return n;
    }

    function formatNumberField(input, decimals = false) { // formats number and puts cursor back in right position.
        let inputVal            = input.val();
        const originalLength    = inputVal.length;
        let caretPosition       = input.prop("selectionStart");

        if (decimals) inputVal  = formatDecimal(inputVal);
        else          inputVal  = formatNumber(inputVal, false);

        input.val(inputVal);

        // put caret back in the right position if we have one
        if (caretPosition) {
            const updatedLength = inputVal.length;
            caretPosition = updatedLength - originalLength + caretPosition;
            input[0].setSelectionRange(caretPosition, caretPosition);
        }
    }

    function getNumericValue(id) {
        let value = $(id).val() || ""; // handle fields removed from the form
        value = value.replace(/[^\d\.]/g, ""); // remove non digit non dot characters
        return +value || 0;
    }

    /***** Style Range Inputs *****/
    $('.af-calculator .calc-input input[type="range"]').each((index, item) => {
        item.style.setProperty('--value', item.value);
        item.style.setProperty('--min', item.min == '' ? '0' : item.min);
        item.style.setProperty('--max', item.max == '' ? '100' : item.max);
        item.addEventListener('input', () => item.style.setProperty('--value', item.value));
    });

    /***** PMI Tooltip *****/
    $('.pmi-tooltip').on('click', function(event) {
        $(event.target.closest('.calc-input')).find('.pmi-tooltip-content').toggleClass('active');
    });

    $(document).on('click', function(event) {
        if (!event.target.closest('.pmi-tooltip') && !event.target.closest('.pmi-tooltip-content')) {
            $('.pmi-tooltip-content').removeClass('active');
        }
    });

    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            $('.pmi-tooltip-content').removeClass('active');
        }
    });

    /***** Outline on Tab *****/
    let keyboardMode = false;

    $(document).on('keydown', function(e) {
        if (e.key === 'Tab') keyboardMode = true;
    });

    $(document).on('mousedown', function() {
        keyboardMode = false;
    });

    $('.calc-fields input[type="number"], .calc-fields input[type="text"], .calc-fields select, .calc-results select')
    .on('focus', function() {
        if (keyboardMode) {
            $(this).addClass('key-focus');
        }
    })
    .on('blur', function() {
        $(this).removeClass('key-focus');
    });

    /***** Advanced Fields Accordion *****/
    function debounce(fn, delay) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => fn(...args), delay);
        };
    }

    $('.js-advanced-fields-button').on('click', function () {
        const button         = $(this);
        const parent         = button.closest('.advanced-fields-wrapper');
        const advancedFields = parent.find('.advanced-fields');

        parent.toggleClass('active');

        const isActive = parent.hasClass('active');
        button.attr('aria-expanded', isActive);
        advancedFields.prop('inert', !isActive); // keep collapsed fields out of the tab order and AT tree

        if (isActive) {
            let height = parent.find('.advanced-fields-inner').outerHeight();
            advancedFields.height(height);
        } else {
            advancedFields.height(advancedFields.outerHeight()); // pin current (possibly auto) height to a concrete px first
            requestAnimationFrame(() => advancedFields.height(0)); // then animate down on the next frame
        }
    })

    $(window).on('resize', debounce(() => {
        $('.advanced-fields-wrapper.active .advanced-fields').css('height', 'auto');
    }, 200));

    /***** Calculate Totals *****/
    function calculateMortgageAPR(id) {
        const amount        = getNumericValue(`#purchase_price-${id}`);
        const downPayment   = getNumericValue(`#down_payment-${id}`);
        const interest      = +$(`#interest_rate-${id}`).val();
        let loanTermYear    = getNumericValue(`#loan_term_year-${id}`);
        const loanFees      = getNumericValue(`#loan_fees-${id}`);
        const points        = +$(`#points-${id}`).val();
        const taxes         = getNumericValue(`#taxes-${id}`) / 12;
        const insurance     = getNumericValue(`#insurance-${id}`) / 12;
        const hoa           = getNumericValue(`#hoa-${id}`);

        if (loanTermYear > 990) {
            loanTermYear = 100;
            $(`#loan_term_year-${id}`).val(loanTermYear);
        }
        const loanTerm = loanTermYear * 12;

        const type =  $(`.af-calculator-${id}`).data('type');

        if (type == 'affordability') {
            const monthlyIncome     = getNumericValue(`#income-${id}`) / 12;
            const monthlyDebts      = getNumericValue(`#monthly_debts-${id}`);
            const maxDebtPercent    = $(`.af-calculator-${id}`).data('debt-limit');
            const maxPaymentPercent = $(`.af-calculator-${id}`).data('payment-limit');

            const monthlyDebtLimit  = (monthlyIncome * maxDebtPercent) - monthlyDebts; // max loan + other costs expense
            const monthlyLoanLimit  = monthlyIncome * maxPaymentPercent; // max loan only expense
            const maxMonthlyPayment = Math.min(monthlyDebtLimit, monthlyLoanLimit); // lower value is the real limit
            const maxPrincipalPayment = maxMonthlyPayment - (taxes + hoa + insurance);

            let maxLoanAmount = calculateMaxLoan(maxPrincipalPayment, loanTerm, interest);
            maxLoanAmount += downPayment;

            $(`#monthly-total-${id}`)           .html(formatNumber(maxMonthlyPayment));
            $(`#monthly-payment-${id}`)         .html(formatNumber(maxPrincipalPayment));
            $(`#monthly-taxes-${id}`)           .html(formatNumber(taxes));
            $(`#monthly-insurance-${id}`)       .html(formatNumber(insurance));
            $(`#monthly-hoa-${id}`)             .html(formatNumber(hoa));
            $(`#all-payments-total-${id} span`) .html(formatNumber(maxLoanAmount));
            return; // that's all we need to calculate for affordability
        }

        // PMI values defaulted to 0 to make other calculations easier
        let monthlyPmi          = 0;
        let pmiPaymentsTotal    = 0;

        // FHA values defaulted to 0 to make other calculations easier
        let monthlyMip          = 0;

        // Needs to be defined globally but only used for buydown calculations
        let buydownFee          = 0;
        let buydownSchedule     = [];

        const downPaymentPercent = downPayment / amount * 100;
        const loanAmount         = amount - downPayment;
        const pointsAmount       = loanAmount * points / 100;

        if (type == 'apr' || type == 'buydown') {
            const pmiPercent    = +$(`#pmi_insurance-${id}`).val();
            let pmiInsurance    = amount * pmiPercent / 100;
            pmiInsurance        = downPaymentPercent >= 20 ? 0 : pmiInsurance;
            monthlyPmi          = pmiInsurance / 12;

            if (downPaymentPercent >= 20) {
                $(`.af-calculator-${id} .pmi-message`).removeClass('d-none');
                $(`.af-calculator-${id} .pmi-message`).siblings(':not(label)').addClass('d-none')
            } else {
                $(`.af-calculator-${id} .pmi-message`).addClass('d-none');
                $(`.af-calculator-${id} .pmi-message`).siblings(':not(label)').removeClass('d-none')
            }
        }

        const monthlyPayment    = calculatePayment(loanAmount, loanTerm, interest);
        const amortization      = calculateAmortization(loanAmount, loanTerm, interest, monthlyPayment);

        if (type == 'apr' || type == 'buydown') {
            let shouldSkip       = false;
            let pmiPaymentsCount = 0;

            amortization.forEach((item, index) => {
                if (!shouldSkip && item.principal <= loanAmount * (0.8 + downPaymentPercent / 100)) {
                    pmiPaymentsCount = index;
                    shouldSkip = true;
                }
            });

            pmiPaymentsTotal = pmiPaymentsCount * monthlyPmi;
        } else if (type == 'fha') {
            const annualFhaMip  = +$(`#annual_fha_mip-${id}`).val();
            monthlyMip          = (annualFhaMip / 100 * loanAmount) / 12;
        } else if (type == 'va') {
            const benefits = $(`#disability_benefits-${id}`).val();

            if (benefits === 'yes') {
                $(`#va-funding-fee-${id}`).html(0);
            } else {
                let percentFee = 0;

                if (downPaymentPercent >= 10) { // fee based on down payment
                    percentFee = $(`#first_time_va-${id}`).data('over-10');
                } else if (downPaymentPercent >= 5) {
                    percentFee = $(`#first_time_va-${id}`).data('over-5');
                } else { // fee based on first/second time
                    percentFee = $(`#first_time_va-${id}`).val();
                }

                const fundingFee = (loanAmount * percentFee / 100);
                $(`#va-funding-fee-${id}`).html(formatNumber(fundingFee));
            }
        }

        if (type == 'buydown') {
            const buydownSchedules = { // map field values to yearly reductions in interest rate
                '1-0':   [1],
                '1-1':   [1, 1],
                '2-1':   [2, 1],
                '3-2-1': [3, 2, 1],
            };
            const buydownType  = $(`#buydown_type-${id}`).val();
            const reductions   = buydownSchedules[buydownType] || [];

            buydownSchedule = reductions.map((reduction, index) => {
                const year              = index + 1;
                const reducedRate       = Math.max(interest - reduction, 0);
                const reducedPayment    = calculatePayment(loanAmount, loanTerm, reducedRate);
                const monthsInYear      = Math.min(12, loanTerm - index * 12);
                const monthlyContribution = monthlyPayment - reducedPayment;

                return {
                    year,
                    rate: reducedRate,
                    payment: reducedPayment, // what the borrower actually pays toward P&I this year
                    contribution: monthlyContribution, // subsidized from the buydown fund this year
                    total: reducedPayment + taxes + hoa + insurance + monthlyPmi, // borrower's full monthly payment this year
                    subsidy: monthlyContribution * monthsInYear, // this year's contribution toward the total buydown fee
                };
            });

            buydownFee = buydownSchedule.reduce((acc, item) => acc + item.subsidy, 0);

            buydownSchedule.push({ // permanent payment once the buydown period ends
                year: reductions.length + 1,
                rate: interest,
                payment: monthlyPayment,
                contribution: 0,
                total: monthlyPayment + taxes + hoa + insurance + monthlyPmi,
                subsidy: 0,
                isPermanent: true,
            });
        }

        const realRate      = calculateInterest(loanAmount - loanFees - pointsAmount - pmiPaymentsTotal, loanTerm, monthlyPayment);
        const extraCosts    = taxes + hoa + insurance + monthlyPmi; // 0 for refinance
        const monthlyTotal  = monthlyPayment + extraCosts + monthlyMip;

        if (type == 'refinance') {
            const remainingYears    = getNumericValue(`#time_remaining_years-${id}`);
            const remainingMonths   = getNumericValue(`#time_remaining_months-${id}`);
            const newYears          = getNumericValue(`#new_loan_term_years-${id}`);
            const newMonths         = getNumericValue(`#new_loan_term_months-${id}`);
            const newInterest       = +$(`#refi_interest-${id}`).val();
            const refinancePoints   = +$(`#refi_points-${id}`).val();
            const cashOut           = getNumericValue(`#cash_out-${id}`);
            const costs             = getNumericValue(`#costs-${id}`);

            const remainingMonthsTotal = remainingYears * 12 + remainingMonths;
            const newMonthsTotal    = newYears * 12 + newMonths;
            const principalIndex    = loanTerm - remainingMonthsTotal > 1 ? loanTerm - remainingMonthsTotal - 1 : 0;
            const remainingAmount   = amortization[principalIndex].principal;
            const pointsCost        = (remainingAmount + cashOut) * refinancePoints / 100;
            const newLoanAmount     = remainingAmount + cashOut - pointsCost;
            const newLoanPayment    = calculatePayment(newLoanAmount, newMonthsTotal, newInterest);

            const currentRemaining  = monthlyPayment * remainingMonthsTotal;
            const newRemaining      = newLoanPayment * newMonthsTotal;

            $(`#monthly-savings-${id} span`).html(formatNumber(monthlyPayment - newLoanPayment));
            $(`#total-savings-${id}`)       .html(formatNumber(currentRemaining - newRemaining));
            $(`#upfront-cost-${id}`)        .html(formatNumber(pointsCost + costs));
            $(`#new-monthly-total-${id}`)   .html(formatNumber(newLoanPayment));
            $(`#monthly-total-${id}`)       .html(formatNumber(monthlyTotal));
        } else {
            $(`#real-apr-${id}`)            .html(realRate.toFixed(3) + '%');
            $(`#monthly-payment-${id}`)     .html(formatNumber(monthlyPayment));
            $(`#monthly-total-${id} span`)  .html(formatNumber(monthlyTotal));
            $(`#monthly-taxes-${id}`)       .html(formatNumber(taxes));
            $(`#monthly-insurance-${id}`)   .html(formatNumber(insurance));
            $(`#monthly-hoa-${id}`)         .html(formatNumber(hoa));

            if (type == 'apr' || type == 'buydown') {
                $(`#pmi-payment-result-${id}`).html(formatNumber(monthlyPmi));
            }

            if (type == 'fha') {
                let upFrontMip  = +$(`#upfront_fha_mip-${id}`).val();
                upFrontMip      = (upFrontMip / 100) * loanAmount;
                $(`#upfront-mip-${id}`).html(formatNumber(upFrontMip));
                $(`#monthly-mip-${id}`).html(formatNumber(monthlyMip));
            } else if (type == 'buydown') {
                $(`#buydown-fee-${id} span`).html(formatNumber(buydownFee));
                renderBuydownSchedule(id, buydownSchedule);

                lastCalculation[id] = {
                    buydownSchedule, amortization, loanAmount, loanTermYear, loanTerm, interest,
                    otherCosts: { taxes, insurance, pmi: monthlyPmi, hoa },
                };
                renderedTabs[id] = {}; // reset tab data to force re-rendering of both tabs on next switch

                // debounce and render only active tab
                debounceChartRender(id, () => renderActiveTabContent(id));
            }
        }
    }

    /***** Affordability Formulas *****/
    function calculateMaxLoan(monthlyPayment, finMonths, finInterest) { // reverse of calculatePayment()
        let finAmount = 0;

        if (finInterest == 0) {
            finAmount = monthlyPayment * finMonths;
        } else {
            let i = ((finInterest / 100) / 12);
            let i_to_m = Math.pow((i + 1), finMonths);

            finAmount = monthlyPayment / ((i * i_to_m) / (i_to_m - 1));
        }

        return finAmount;
    }

    /***** APR Formulas *****/
    function calculatePayment(finAmount, finMonths, finInterest) {
        if (finMonths == 0) return 0; // prevent division by 0
        let result = 0;

        if (finInterest == 0) {
            result = finAmount / finMonths;
        } else {
            let i = ((finInterest / 100) / 12),
                i_to_m = Math.pow((i + 1), finMonths),
                p = finAmount * ((i * i_to_m) / (i_to_m - 1));
            result = Math.round(p * 100) / 100;
        }

        return result;
    }

    function calculateAmortization(finAmount, finMonths, finInterest, payment) {
        let balance = finAmount,
            totalInterest = 0.0,
            schedule = [],
            currInterest = null,
            currPrincipal = null;

        for (let i = 0; i < finMonths; i++) {
            const isLastPayment = i === finMonths - 1;

            currInterest = balance * finInterest / 1200;
            totalInterest += currInterest;
            // the fixed, rounded-to-the-cent payment almost never zeroes the balance exactly over
            // the full term — the last payment absorbs whatever's left
            currPrincipal = isLastPayment ? balance : payment - currInterest;
            balance -= currPrincipal;

            schedule.push({
                principal: balance,
                interest: totalInterest,
                payment: isLastPayment ? currPrincipal + currInterest : payment,
                paymentToPrincipal: currPrincipal,
                paymentToInterest: currInterest,
            });
        }

        return schedule;
    }

    function calculateInterest(finAmount, finMonths, finPayment, periods = 12) {
        let min_rate = 0, max_rate = 100, mid_rate = 0;

        while (min_rate < (max_rate - 0.0001)) {
            mid_rate = (min_rate + max_rate) / 2;
            let j = mid_rate / (periods * 100),
                guessed_pmt = finAmount * ( j / (1 - Math.pow(1 + j, finMonths * -1)));

            if (guessed_pmt > finPayment) {
                max_rate = mid_rate;
            } else {
                min_rate = mid_rate;
            }
        }

        return mid_rate;
    }

    /***** Buydown Year Selector *****/
    function renderBuydownSchedule(id, schedule) {
        const select        = $(`#buydown-year-select-${id}`);
        const previousValue = select.val();
        const validValue     = schedule.some((item) => `${item.year}` === previousValue)
            ? previousValue
            : `${schedule[0].year}`;

        select.data('schedule', schedule);
        select.html(schedule.map((item) =>
            `<option value="${item.year}">Year ${item.year}${item.isPermanent ? '+' : ''}</option>`
        ).join(''));
        select.val(validValue);

        updateBuydownYearDisplay(id, schedule, validValue);

        for (let slot = 1; slot <= 4; slot++) { // 4 covers longest schedule (3/2/1) plus its permanent year
            const item = schedule.find((entry) => entry.year === slot);

            $(`#buydown-year-${slot}-payment-${id}`)      .html(item ? formatNumber(item.payment) : '');
            $(`#buydown-year-${slot}-contribution-${id}`) .html(item ? formatNumber(item.contribution) : '');
            $(`#buydown-year-${slot}-total-${id}`)        .html(item ? formatNumber(item.total) : '');

            $(`#buydown-year-${slot}-${id}`).toggleClass('d-none', `${slot}` !== validValue);
        }
    }

    function updateBuydownYearDisplay(id, schedule, selectedYear) {
        const entry = schedule.find((item) => `${item.year}` === `${selectedYear}`);

        $(`#buydown-year-label-${id}`)          .html(entry ? `${entry.rate}% Interest Rate` : '');
        $(`#buydown-legend-payment-${id}`)      .html(entry ? '$' + formatNumber(entry.payment) : '');
        $(`#buydown-legend-contribution-${id}`) .html(entry ? '$' + formatNumber(entry.contribution) : '');

        const summary = $(`#buydown-chart-summary-${id}`);
        if (!entry) { summary.html(''); return; }

        summary.html(entry.isPermanent
            ? `Starting Year <span>${entry.year}</span>, your rate returns to <span>${entry.rate}%</span> and your total payment is <span>$${formatNumber(entry.total)}</span>/month. The buydown period has ended.`
            : `In Year <span>${entry.year}</span>, your rate is reduced to <span>${entry.rate}%</span>, bringing your total payment to <span>$${formatNumber(entry.total)}</span>/month. The buydown fund is separately contributing <span>$${formatNumber(entry.contribution)}</span>/month toward your loan on your behalf.`
        );
    }

    $(document).on('change', '.buydown-year-select', function() {
        const select        = $(this);
        const parentId      = select.parents('.af-calculator').data('id');
        const selectedYear  = select.val();
        const schedule      = select.data('schedule') || [];

        $(`.af-calculator-${parentId} .buydown-year`).addClass('d-none');
        $(`#buydown-year-${selectedYear}-${parentId}`).removeClass('d-none');
        updateBuydownYearDisplay(parentId, schedule, selectedYear);
    });

    /***** Buydown / Amortization Chart Tooltips *****/
    // moveChartTooltip() position is calculated from the viewport, but appending to body makes it shared between calculators
    const chartTooltip = $('<div class="af-calculator-chart-tooltip" aria-hidden="true"></div>').appendTo('body');

    function showChartTooltip(html, typeClass) {
        chartTooltip.html(html).removeClass('amortization buydown').addClass(`active ${typeClass}`);
    }

    function moveChartTooltip() {
        chartTooltip.css({ left: d3.event.clientX + 14, top: d3.event.clientY + 14 });
    }

    function hideChartTooltip() {
        chartTooltip.removeClass('active');
    }

    // snaps the tooltip to the hovered year's gridline. Years in the first half of the term align to the right
    // of their line, years in the second half align to the left, so the tooltip is always inside the chart area.
    function snapAmortizationTooltip(svg, lineX, viewBoxWidth, alignRight) {
        const gap    = 8;
        const rect   = svg.node().getBoundingClientRect();
        const scaleX = rect.width / viewBoxWidth;

        const lineClientX = rect.left + lineX * scaleX;

        const tooltipWidth = chartTooltip.outerWidth();
        const left = alignRight
            ? lineClientX + gap
            : lineClientX - gap - tooltipWidth;

        // centered vertically on the chart
        const top = rect.top + rect.height / 2 - chartTooltip.outerHeight() / 2;

        chartTooltip.css({ left, top }).removeClass('left right').addClass(alignRight ? 'left' : 'right');
    }

    /***** Buydown Payment Breakdown Chart (D3 v3 API) *****/
    function renderBuydownBarChart(id, schedule, otherCosts) { // otherCosts: taxes, hoa, insurance, pmi
        const chartSegments = [ // bottom to top
            { key: 'payment',      label: 'Principal & Interest', perYear: true },
            { key: 'pmi',          label: 'PMI' },
            { key: 'insurance',    label: 'Insurance' },
            { key: 'taxes',        label: 'Taxes' },
            { key: 'hoa',          label: 'HOA' },
            { key: 'contribution', label: 'Buydown Contribution', perYear: true },
        ];
        const segmentValue = (segment, entry) => segment.perYear ? entry[segment.key] : otherCosts[segment.key];

        // constant across every year; set once
        chartSegments.filter((s) => !s.perYear).forEach((segment) => {
            $(`#buydown-legend-${segment.key}-${id}`).html('$' + formatNumber(otherCosts[segment.key]));
        });

        const svg = d3.select(`#buydown-bar-chart-${id}`);
        svg.selectAll('*').remove(); // full redraw on change

        const width  = 600;
        const height = 320;

        const x = d3.scale.ordinal()
            .domain(schedule.map((entry) => entry.year))
            .rangeRoundBands([0, width], 0.35);

        const maxTotal = d3.max(schedule, (entry) => chartSegments.reduce((sum, s) => sum + segmentValue(s, entry), 0));

        const y = d3.scale.linear()
            .domain([0, maxTotal])
            .range([height, 0])
            .nice();

        const yTicks = y.ticks(5);

        svg.selectAll('.buydown-chart-gridline')
            .data(yTicks)
            .enter().append('line')
                .attr('class', 'buydown-chart-gridline')
                .attr('x1', 0)
                .attr('x2', width)
                .attr('y1', (value) => y(value))
                .attr('y2', (value) => y(value));

        // HTML labels, positioned at the same coordinates as the bars/gridlines
        $(`#buydown-chart-x-labels-${id}`).html(schedule.map((entry) => {
            const centerPercent = (x(entry.year) + x.rangeBand() / 2) / width * 100;
            return `<p style="left:${centerPercent}%">Year ${entry.year}${entry.isPermanent ? '+' : ''}</p>`;
        }).join(''));

        $(`#buydown-chart-y-labels-${id}`).html(yTicks.map((value) => {
            const topPercent = y(value) / height * 100;
            return `<p style="top:${topPercent}%">$${formatNumber(value)}</p>`;
        }).join(''));

        schedule.forEach((entry) => {
            let cumulative = 0; // stack boundaries computed directly from the scale, so adjacent segments share an exact edge

            chartSegments.forEach((segment, index) => {
                const value  = segmentValue(segment, entry);
                const isBottomSegment = index === 0;
                // extend only the bottom-most segment past the true edge to fix Chrome anti-aliasing gap
                const yStart = y(cumulative) + (isBottomSegment ? 1 : 0);
                const yEnd   = y(cumulative + value);
                cumulative += value;

                svg.append('rect')
                    .attr('class', `buydown-bar buydown-bar-${segment.key}`)
                    .attr('x', x(entry.year))
                    .attr('y', yEnd)
                    .attr('width', x.rangeBand())
                    .attr('height', Math.max(yStart - yEnd, 0))
                    .on('mouseover', function() {
                        const tooltipHtml = `
                            <span>Year ${entry.year}${entry.isPermanent ? '+' : ''}</span>
                            <span>${segment.label}</span>
                            <span>$${formatNumber(value)}</span>
                        `;
                        showChartTooltip(tooltipHtml, 'buydown');
                    })
                    .on('mousemove', moveChartTooltip)
                    .on('mouseout', hideChartTooltip);
            });
        });
    }

    /***** Amortization Chart (D3 v3 API) *****/
    function renderAmortizationChart(id, amortization, loanAmount, loanTermYear) {
        const amortizationLines = [
            { key: 'remaining', label: 'Remaining Balance' },
            { key: 'principal', label: 'Principal Paid' },
            { key: 'interest',  label: 'Interest Paid' },
        ];

        // one data point per year, sampled at that year's final month
        const points = [];
        for (let year = 1; year <= loanTermYear; year++) {
            const monthIndex = Math.min(year * 12, amortization.length) - 1;
            const entry       = amortization[monthIndex];

            points.push({
                year,
                remaining: entry.principal,
                principal: loanAmount - entry.principal,
                interest: entry.interest,
            });
        }

        const svg = d3.select(`#amortization-line-chart-${id}`);
        svg.selectAll('*').remove();

        const width  = 600;
        const height = 220;

        const x = d3.scale.linear()
            .domain([1, loanTermYear])
            .range([0, width]);

        const maxValue = d3.max(points, (point) => Math.max(point.remaining, point.principal, point.interest));

        const y = d3.scale.linear()
            .domain([0, maxValue])
            .range([height, 0])
            .nice();

        // vertical gridlines, one per year, doubling as the visual reference the x-labels line up with
        svg.selectAll('.amortization-chart-gridline')
            .data(points)
            .enter().append('line')
                .attr('class', 'amortization-chart-gridline')
                .attr('x1', (point) => x(point.year))
                .attr('x2', (point) => x(point.year))
                .attr('y1', 0)
                .attr('y2', height);

        // cap at 30 labels, skipping years evenly after that
        const maxLabels = 30;
        const labelStep = Math.ceil(loanTermYear / maxLabels);

        $(`#amortization-chart-x-labels-${id}`).html(points.filter((point) => point.year % labelStep === 0).map((point) => {
            const leftPercent = x(point.year) / width * 100;
            return `<p style="left:${leftPercent}%">${point.year}</p>`;
        }).join(''));

        amortizationLines.forEach((lineConfig) => {
            const linePath = d3.svg.line()
                .x((point) => x(point.year))
                .y((point) => y(point[lineConfig.key]));

            svg.append('path')
                .attr('class', `amortization-line amortization-line-${lineConfig.key}`)
                .attr('d', linePath(points));
        });

        // each year's hover zone spans the midpoints to its neighboring years (nearest-gridline
        // assignment). The first/last points have no neighbor on one side, so their zone extends
        // to the chart's edge on that side.
        points.forEach((point, index) => {
            const currentX = x(point.year);
            const prevX    = index === 0 ? currentX : x(points[index - 1].year);
            const nextX    = index === points.length - 1 ? currentX : x(points[index + 1].year);

            const zoneLeft  = index === 0 ? 0 : (prevX + currentX) / 2;
            const zoneRight = index === points.length - 1 ? width : (currentX + nextX) / 2;

            const lineX = x(point.year);

            svg.append('rect')
                .attr('class', 'amortization-hover-zone')
                .attr('x', zoneLeft)
                .attr('y', 0)
                .attr('width', zoneRight - zoneLeft)
                .attr('height', height)
                .on('mouseover', function() {
                    const rows = amortizationLines.map((lineConfig) =>
                        `<div class="af-calculator-chart-tooltip-row"><span class="amortization-line-${lineConfig.key}"></span>${lineConfig.label}: $${formatNumber(point[lineConfig.key])}</div>`
                    ).join('');
                    showChartTooltip(`<strong>Year ${point.year}</strong>${rows}`, 'amortization');
                    snapAmortizationTooltip(svg, lineX, width, point.year <= loanTermYear / 2);
                })
                .on('mousemove', function() {
                    snapAmortizationTooltip(svg, lineX, width, point.year <= loanTermYear / 2);
                })
                .on('mouseout', hideChartTooltip);
        });
    }

    /***** Amortization Table *****/
    function addMonths(date, months) {
        return new Date(date.getFullYear(), date.getMonth() + months, 1);
    }

    function formatMonthYear(date) {
        return new Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric' }).format(date);
    }

    function renderAmortizationTable(id, amortization, loanAmount, loanTermYear, loanTerm, interest) {
        const today         = new Date();
        const startDate     = new Date(today.getFullYear(), today.getMonth() + 1, 1); // start next month
        const payoffDate    = addMonths(startDate, loanTerm);
        const totalInterest = amortization[amortization.length - 1].interest;

        $(`#amortization-table-start-date-${id}`)    .html(formatMonthYear(startDate));
        $(`#amortization-table-payoff-date-${id}`)   .html(formatMonthYear(payoffDate));
        $(`#amortization-table-loan-period-${id}`)   .html(`${loanTermYear} years`);
        $(`#amortization-table-payments-${id}`)      .html(loanTerm);
        $(`#amortization-table-total-interest-${id}`).html('$' + formatNumber(totalInterest));
        $(`#amortization-table-interest-rate-${id}`) .html(`${interest}%`);

        let runningTotalPayments = 0;
        const rows = amortization.map((entry, index) => {
            const totalPrincipal = loanAmount - entry.principal;
            runningTotalPayments += entry.payment; // entry.payment differs from monthlyPayment on the final row

            return `
                <tr>
                    <td>${index + 1}</td>
                    <td>${formatMonthYear(addMonths(startDate, index))}</td>
                    <td>$${formatNumber(entry.payment)}</td>
                    <td>$${formatNumber(entry.paymentToInterest)}</td>
                    <td>$${formatNumber(entry.interest)}</td>
                    <td>$${formatNumber(entry.paymentToPrincipal)}</td>
                    <td>$${formatNumber(totalPrincipal)}</td>
                    <td>$${formatNumber(runningTotalPayments)}</td>
                    <td>$${formatNumber(entry.principal)}</td>
                </tr>
            `;
        }).join('');

        $(`#amortization-table-body-${id}`).html(rows);
    }

    /***** Payment Breakdown / Amortization Tabs *****/
    const chartRenderTimers = {};
    function debounceChartRender(id, renderFn) { // keyed by id so calculators are independent
        clearTimeout(chartRenderTimers[id]);
        chartRenderTimers[id] = setTimeout(renderFn, 150);
    }

    // globally cache last calculation results to render the chart/table on tab switch without calculateMortgageAPR() context
    const lastCalculation = {};

    // skip tab re-rendering if the calculation data hasn't changed since the last time that tab was rendered
    const renderedTabs = {};

    function getActiveTab(id) {
        return $(`.af-calculator-${id} [role="tab"][aria-selected="true"]`).data('tab');
    }

    function renderActiveTabContent(id) {
        const data = lastCalculation[id];
        if (!data) return;

        const activeTab = getActiveTab(id);
        if (renderedTabs[id]?.[activeTab]) return; // already reflects the current data, nothing to do
        renderedTabs[id] = renderedTabs[id] || {};
        renderedTabs[id][activeTab] = true;

        if (activeTab === 'payment') {
            renderBuydownBarChart(id, data.buydownSchedule, data.otherCosts);
            return;
        }

        const termTooLong = data.loanTermYear > 100; // pause table/chart rendering for unreasonably long terms
        $(`#amortization-term-warning-${id}`).prop('hidden', !termTooLong);
        $(`.af-calculator-${id} .amortization-chart, .af-calculator-${id} .amortization-table`).prop('hidden', termTooLong);
        if (termTooLong) return;

        renderAmortizationChart(id, data.amortization, data.loanAmount, data.loanTermYear);
        renderAmortizationTable(id, data.amortization, data.loanAmount, data.loanTermYear, data.loanTerm, data.interest);
    }

    // Tab visibility handled by .js-tab-group in main.js. Graph rendering bound on document so it's
    // guaranteed to run after the tab has become visible due to event bubbling.
    $(document).on('click', '.js-calc-tab', function() {
        const tab = $(this);

        // inner tab (Payment/Amortization): lives inside its own calculator
        let id = tab.closest('.af-calculator').data('id');

        // outer tab (Mortgage/Buydown/Refinance): find the buydown calculator inside the panel it reveals
        if (id === undefined) {
            const panel = $('#' + tab.attr('aria-controls'));
            id = panel.find('.af-calculator[data-type="buydown"]').data('id');
        }

        if (id === undefined) return; // not a buydown-related tab (e.g. the apr/refinance outer tabs)

        renderedTabs[id] = {}; // force a fresh render — a previous render may have happened while hidden
        renderActiveTabContent(id);
    });

    /***** Initial Calculation on Page Load *****/
    $('.af-calculator').each((index, item) => {
        const id = $(item).data('id');
        calculateMortgageAPR(id); // calculate initial values on load

        // add aria-live after the initial calculation to avoid announcing it on page load
        $(item).find('.js-calc-init-live').attr('aria-live', 'polite');
    });
});
